<script lang="ts">
	import type { SizeProps } from "../../templates/WeddingsProps";
	import { nbspify } from "../../../../core/utils/nbspify";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { WeddingCakeDecorationStyle } from "../../../../core/schema/WeddingCakeDecorationStyle";
	import { weddingCakeDecorationStyleNameMap } from "../../../../core/schema/names/weddingCakeDecorationStyleNameMap";
	import { getGlobalSettings } from "../../getGlobalSettings";

	export let cakeSizeOption: SizeProps;
	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;

	$: withDescription = cakeSizeOption.height && cakeSizeOption.pad;
</script>

<div class="glide__slide">
	<div
		class="relative mx-auto flex h-[25rem] !w-[13.5rem] flex-col items-center rounded-lg border border-secondary-200 p-4 lg:h-[28.75rem] lg:!w-[18rem]"
		class:min-[500px]:items-start={withDescription}
	>
		<div
			class="flex w-full flex-col gap-2 lg:flex-row {!withDescription
				? 'mb-14 items-center justify-center lg:mb-7'
				: 'mb-2 items-baseline justify-between'}"
		>
			<p class="text-base font-semibold lg:text-md">{cakeSizeOption.portions} porcí</p>
			{#if withDescription}
				<div class="flex flex-col text-xs lg:items-end lg:text-base">
					<p>{nbspify(`výška - max ${cakeSizeOption.height} cm`)}</p>
					<p>{nbspify(`podložka - max ${cakeSizeOption.pad} cm`)}</p>
				</div>
			{/if}
		</div>
		{#if cakeSizeOption.desc}
			<p class="absolute left-4 right-4 top-[6.125rem] text-3xs lg:top-[5.5rem] lg:text-center lg:text-2xs">
				{nbspify(cakeSizeOption.desc)}
			</p>
		{/if}
		<StaticPicture
			class="mb-[1.5rem] flex h-[12.5rem] items-end pb-6 lg:h-[16.875rem] lg:pb-10"
			image={cakeSizeOption.image}
			alt={cakeSizeOption.alt ?? "Vizualizace svatebního dortu"}
			height={270}
			width={246}
			loading="lazy"
		/>

		<div class="grid w-full grid-cols-2 grid-rows-4 text-xs lg:text-base">
			{#each Object.values(WeddingCakeDecorationStyle).filter((value) => value !== WeddingCakeDecorationStyle.Individual) as variant}
				<span class="font-semibold lowercase">{weddingCakeDecorationStyleNameMap[variant][TENANT_LOCALE]}</span>
				<span class="text-right">{cakeSizeOption.variants[variant]}</span>
			{/each}
		</div>
	</div>
</div>
